<template>
        <v-container fluid>
          <v-row>
          <v-col cols="auto">
            <v-icon :color="iconColor" :size="iconSize"> {{icon}} </v-icon>
          </v-col>
          <v-col>
            <div :style="textColor">
             <b>{{ type }}</b>
            </div>
            <div :style="textColor">
              {{ msg }}
            </div>
          </v-col>
        </v-row>
      </v-container>
</template>
<script>
export default{
  props:["iconColor", "iconSize", "icon","textColor","type","msg"] 
}
</script>